"use client";
import Plus from "./assets/plus_bracket.svg";
import Minus from "./assets/minus_bracket.svg";
import { useState } from "react";
import { PrismicNextLink } from "@prismicio/next";

export default function Dropdown({ slice, topPosition }) {
  const [expanded, setExpanded] = useState(false);
  const [subExpandedItems, setSubExpandedItems] = useState({});

  function onClickHandler() {
    setExpanded((prev) => !prev);
  }

  function onClickSubItemHandler(idx) {
    setSubExpandedItems((prev) => ({
      [idx]: !prev[idx],
    }));
  }

  return (
    <li
      className={`text-base ${topPosition ? "dropdown-top-position-margin" : "dropdown-bottom-position-margin"}`}
    >
      <div className="cursor-pointer flex items-center gap-[6px] footer-text-hover">
        <PrismicNextLink
          className="text-[#C4C4C8] block duration-200 footer-text-hover"
          field={slice?.primary?.dropdown_menu_link}
        >
          {slice?.primary?.dropdown_menu_label}
        </PrismicNextLink>
        <div onClick={onClickHandler}>
          <img
            className="h-[20px] w-[20px]"
            src={expanded ? Minus.src : Plus.src}
            alt="icon"
          />
        </div>
      </div>

      <div
        className="overflow-hidden"
        style={{
          maxHeight: expanded ? `1000px` : "0px",
          paddingTop: expanded ? `6px` : "0px",
          transition: "all 0.4s",
        }}
      >
        <ul>
          {slice?.primary?.dropdown_links?.map((item, idx) => {
            return (
              <li
                className="text-[14px] mb-[4px] last:mb-0"
                key={idx}
                style={{ paddingLeft: 26 }}
              >
                {item?.subitems?.length > 0 ? (
                  <div
                    className="cursor-pointer flex items-center gap-[6px]"
                    onClick={() => onClickSubItemHandler(idx)}
                  >
                    <span className="leading-6 footer-sub-link footer-text-hover">
                      {item?.label}
                    </span>
                    <img
                      className="h-[20px] w-[20px]"
                      src={subExpandedItems[idx] ? Minus.src : Plus.src}
                      alt="icon"
                    />
                  </div>
                ) : (
                  <PrismicNextLink
                    className="block leading-5 duration-200 footer-text-hover footer-sub-link"
                    field={item?.link}
                  >
                    {item?.label}
                  </PrismicNextLink>
                )}

                {item?.subitems?.length > 0 && (
                  <div
                    className="overflow-hidden"
                    style={{
                      maxHeight: subExpandedItems[idx] ? `1000px` : "0px",
                      paddingTop: subExpandedItems[idx] ? `6px` : "0px",
                      transition: "all 0.4s",
                    }}
                  >
                    <ul>
                      {item?.subitems?.map((subitem, subIdx) => (
                        <li
                          className="text-[14px] leading-5 mb-[4px] last:mb-0"
                          key={subIdx}
                          style={{ paddingLeft: 26 }}
                        >
                          <PrismicNextLink
                            className="block duration-200 footer-text-hover footer-sub-link"
                            document={subitem}
                          >
                            {subitem?.text}
                          </PrismicNextLink>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </li>
  );
}
